import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-light-svg-icons';
import { generatePath, Link } from 'react-router-dom';
import { IconButton } from '@nexelem/components';
import { NodeIcon } from '../../../../../../../../components/organisms/ProductionPlans/Gantt/components';
import { orderStatusMap as salesOrderStatusMap } from '../../../../../../Orders/utils/orderStatusMap';
import { getAbsolutePath, ROUTES } from '../../../../../../../../routes/config';
import { ORDER_AVAILABLE_PATH_TABS } from '../../../../../../Orders/enums';
import { useCustomTranslation } from '../../../../../../../../hooks';
import { OrderView } from '@nexelem/api';
import { useMemo } from 'react';
import { useConfigRouteContext } from '../../../../../../../../providers';
import { ordersOutletRouteId, orderDetailsRouteId } from '../../../../../../Orders/constants';

type SalesOrderItemProps = {
  data?: OrderView[];
  buyerName: Record<number, string | undefined>;
};

export const SalesOrderItem = ({ data = [], buyerName }: SalesOrderItemProps) => {
  const { routeConfig } = useConfigRouteContext();
  const { tWrapper } = useCustomTranslation('products.productionPlan.taskDetailsDrawer');
  const { t: ordersT } = useCustomTranslation('orders');

  const hasAccessToOrdersDetails = useMemo(() => {
    const ordersRoute = routeConfig.find((route) => route.props.key === ordersOutletRouteId);
    return ordersRoute?.props.children?.some((route) => route.props.key === orderDetailsRouteId);
  }, [routeConfig]);

  if (data.length === 0) {
    return null;
  }

  return (
    <>
      {data.map((order) => (
        <div className="flex items-center gap-3 border-b border-border-container py-3 pr-2 pl-4" key={order.id}>
          <NodeIcon isOrder statusColor={salesOrderStatusMap(ordersT, order.status)?.color || 'grey'} />
          <div className="flex grow flex-col gap-1">
            <span className="text-s16-sb text-text-primary">{order.supplierNumber || '-'}</span>
            <span className="text-s11-sb text-text-primary uppercase">{buyerName[order.id] || '-'}</span>
            <span className="text-s11-sb text-text-secondary uppercase">{tWrapper('salesOrder')}</span>
          </div>
          {hasAccessToOrdersDetails && (
            <Link
              target="_blank"
              to={getAbsolutePath(
                generatePath(ROUTES.orders.details.full, {
                  id: order.id.toString(),
                  tab: ORDER_AVAILABLE_PATH_TABS.BASE,
                }),
              )}
            >
              <IconButton Icon={() => <FontAwesomeIcon icon={faArrowUpRightFromSquare} />} size="small" />
            </Link>
          )}
        </div>
      ))}
    </>
  );
};
